module.exports = __webpack_public_path__ + "static/media/img-talent-profile-rating.e1c93316.png";